import React from "react";
import { withRouter } from "react-router-dom";
import Edititemform from "./components/Editextraitemform";
function Editextraitem() {
  return <Edititemform></Edititemform>;
}
export default withRouter(Editextraitem);
